export const selectContentImpressionState = (state) => state.contentImpression

export const selectContentImpressionData = (state) => state.contentImpression.get('data')
